<template>
    <div class="promo_section">
        <i class="uis uis-bill"></i>
        <h2>Promo Codes</h2>
        <h2>This section is under construction</h2>
    </div>
</template>

<script>
export default {

}
</script>

<style>
.promo_section {
    padding-top: 2rem;

    i {
        font-size: 2rem;
    }
}
</style>